import React from 'react';
import facebook from './QuestionStep/assets/facebook.png'
import linkdin from './QuestionStep/assets/linkdin.png'
import mail from './QuestionStep/assets/mail.png'
import twit from './QuestionStep/assets/twit.png'
import whatsapp from './QuestionStep/assets/whatsapp.png'
import { useLocalize } from 'localize-react';

export default function Socials(props) {
    console.log(props);
    const { translate } = useLocalize()

    return (
        <>
            <div className="socials-wrapper">
                <div className={props.page === 'result-page' ? 'ThankSoText result-page': 'ThankSoText'}>
                {translate('Share Our Calculator')}
                </div>
                <div className={props.page === 'result-page' ? 'Social result-page': 'Social'}>
                    <a 
                    href="https://api.whatsapp.com/send?text=היי, קיבלתי את הכלי הזה, מחשבון שבודק כמה כנראה עולה לנו הבנק. ממליץ לך לנסות גם, זה ממש מפתיע: https://www.onezerobank.com/calc/" 
                    data-action="share/whatsapp/share" 
                    target="_blank"><img className="whatsapp"  width="19px" src={whatsapp} alt="" 
                    aria-label="שיתוף ב-וואטסאפ"
                    /></a>
                    <a 
                    href="https://www.facebook.com/sharer/sharer.php?u=https://www.onezerobank.com/calc/"
                    aria-label="שיתוף ב-פייסבוק"

                     target="_blank">
                         <img className="facebook" width="10px" src={facebook} alt="" /></a>
                    <a 
                    href="http://www.linkedin.com/shareArticle?mini=true&url=onezerobank.com/calc/?&title=%D7%94%D7%99%D7%99%2C%20%D7%A7%D7%99%D7%91%D7%9C%D7%AA%D7%99%20%D7%90%D7%AA%20%D7%94%D7%9B%D7%9C%D7%99%20%D7%94%D7%96%D7%94%2C%20%D7%9E%D7%97%D7%A9%D7%91%D7%95%D7%9F%20%D7%A9%D7%91%D7%95%D7%93%D7%A7%20%D7%9B%D7%9E%D7%94%20%D7%9B%D7%A0%D7%A8%D7%90%D7%94%20%D7%A2%D7%95%D7%9C%D7%94%20%D7%9C%D7%A0%D7%95%20%D7%94%D7%91%D7%A0%D7%A7.%20%D7%9E%D7%9E%D7%9C%D7%99%D7%A5%20%D7%9C%D7%9A%20%D7%9C%D7%A0%D7%A1%D7%95%D7%AA%20%D7%92%D7%9D%2C%20%D7%96%D7%94%20%D7%9E%D7%9E%D7%A9%20%D7%9E%D7%A4%D7%AA%D7%99%D7%A2" 
                    target="_blank"
                    aria-label="שיתוף ב-לינקדאין"
                    ><img className="linkdin" width="20px" src={linkdin} alt="" /></a>
                </div>
            </div>
        </>
    )
}
